import { IntervalAction } from './IntervalAction';
import { EventDispatcher } from './EventDispatcher';
import { EventStream } from './EventStreamSubscription';

export abstract class ValueAction<T> extends IntervalAction {
  private _valueChange: EventDispatcher<T> = new EventDispatcher<T>();

  get valueChange(): EventStream<T> {
    return this._valueChange.eventStream;
  }

  dispatchValueChange(val: T): void {
    this._valueChange.dispatchEvent(val);
  }
}
